
import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainAttachment, Glitch_UpdateRequest,ComplainEnableKMT, JobInventoryDetails, JobInventoryLocationsDetails, InventoryItemsPayload } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, JobOperationActions, MasterConstants, ComplainType, Priorities, JobPopoverMode, Modules, InventoryItemType, InventoryTransactionTypes } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import * as _ from 'lodash';
import * as moment from 'moment';
const momentDuration = require("moment-duration-format");
import { ComplainService } from '../../Services/ComplainService';
import { TopFilterStatModel } from '../../Models/CommonModels';
import { JobOperations } from '../JobOperations/JobOperations';
import { ManualAssign } from '../ManualAssign/ManualAssign';
import { GSRAudit } from '../GSRAudit/GSRAudit';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EntityCodes } from '../../Models/EnumModels';
import { TagStaff } from '../TagStaff/TagStaff';
import { SendMsg } from '../SendMsg/SendMsg';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { AppSettings } from '../../Library/AppSettings';

@Component({
    selector: 'JobPopover',
    templateUrl: './JobPopover.html'
})

export class JobPopover extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild("jobOperations") jobOperations: JobOperations;
    @ViewChild("manualAssign") manualAssign: ManualAssign;
    @ViewChild("gsrAudit") gsrAudit: GSRAudit;
    @ViewChild("tagStaff") tagStaff: TagStaff;
    @ViewChild('sendMsg') sendMsg: SendMsg;

    Model: any;
    _LocationId: number;
    DateFormat: string;
    PropStatModel: Array<TopFilterStatModel> = [];
    Timer: any;
    cDate: Date = new Date();
    HistoryData: any;
    UpdateModel: ComplainRegister;
    _JobOperationActions = JobOperationActions;
    _CallStatuses = CallStatuses;
    _MasterConstants = MasterConstants;
    _ComplainType = ComplainType;
    GSRAuditData: any;
    _Priorities = Priorities;

    @Input() Mode: JobPopoverMode = JobPopoverMode.Default;
    @Input() increasePopupOpacity: boolean = false;
    _JobPopoverMode = JobPopoverMode;
    _Modules = Modules;
    HistoryPageNumber = 1;
    HistoryPageSize = 50;
    JobInventoryDetail = new JobInventoryDetails();
    JobInventoryLocations = new JobInventoryLocationsDetails();
    inventorySingularityEnabled: boolean = false;
    inventoryItempType: string = '';
    InventoryItemType = InventoryItemType;
    InventoryTransactionTypes = InventoryTransactionTypes;
    workOrderRemarks: string = null;
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);

        let m: any;
        m = momentDuration;
        m(moment);
    }

    ngOnDestroy(): void {
    }

    @Input() set Selected(data: any) {

        if (this.Model != null && data != null && this.Model.ComplainId == data.ComplainId)
            return;

        this.Model = data;
        this.SetUpdateModel();

        if (this.Model != null) {
            this.Model.TimeTakenVarianceText = "";

            if (this.Model.TimeTakenVariance != null) {
                let timeVar = moment.duration(Math.abs(this.Model.TimeTakenVariance), 'seconds');
                this.Model.TimeTakenVarianceText = timeVar.format("dd:hh:mm", {
                    trim: false
                });
            }
        }

        this.onOpen();
    }

    SetUpdateModel(): void {
        if (this.Model == null)
            return;

        this.UpdateModel = new ComplainRegister();
        this.UpdateModel.AssignedTo = this.Model.AssignedTo;//null
        this.UpdateModel.Attachments = this.Model.Attachments;
        this.UpdateModel.CallDescriptionsId = this.Model.CallDescriptionsId;
        this.UpdateModel.CategoryId = this.Model.CategoryId;
        this.UpdateModel.ClosedReasonCode = 0;
        this.UpdateModel.ClosedReasonCode_Close = 0;
        this.UpdateModel.ClosedReasonCode_Park = 0;
        this.UpdateModel.ComplainId = this.Model.ComplainId;
        this.UpdateModel.CurrentStatus = this.Model.CurrentStatus;
        this.UpdateModel.IsAutoAssign = true;

        this.UpdateModel.LocationId = this.Model.LocationId;
        this.UpdateModel.PropertyId = this.Model.PropertyId;
    }


    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        if(this.masterService.CheckActiveLicence_Module(this.masterService.ActivePropertyID, 'UF_INV') && AppSettings.IsRunningInSingularity ){
            this.inventorySingularityEnabled = true;
            this.jobOperations.inventorySingularityEnabled = true;
        }
        this.SetData();
        this.complainService.JobConsoleRefreshEvent.pipe(untilDestroyed(this)).subscribe((ComplainId) => {
            if (this.Model && ComplainId == this.Model.ComplainId) {
                this.refreshData();
            }
        });

        this.complainService.ComplainRowChanged.pipe(untilDestroyed(this)).subscribe((data) => {
            if (this.Model && data.ComplainId == this.Model.ComplainId) {
                this.refreshData();
            }
        });
    }

    SetData(): void {
        this.refreshData();
        this.SetUpdateModel();
    }

    refreshData(){
        this.GetHistory().then(() => {
            this.GetWorkOrderRemarks();
        });
        this.GetGSRAudit();
        if(this.inventorySingularityEnabled){
            this.setInventoryItemType();
            this.GetInventoryDetails();
            this.getGuestDataInventory();
        }
    }

    onOpen(): void {
        this.SetData();
    }

    GetGSRAudit(): void {
        if (this.Model == null)
            return;

        this.IsSubmitting = true;
        this.complainService.Complain_GetGSRAudit(this.Model.ComplainId).then(data => {
            if (data.GSRData) {
                this.GSRAuditData = data.GSRData;
                this.IsSubmitting = false;
                this.TransformGSRAudit();
            }
        }).catch(err => {
            this.IsSubmitting = false;
        });
    }

    TransformGSRAudit():void {
        for (let i = 0; i < this.GSRAuditData.length; i++) {
            this.GSRAuditData[i].AuditorName = this.masterService.MasterData_GetMutli(this.Model.PropertyId, this.GSRAuditData[i].AuditorId, EntityCodes.Staff, "")
        }
    }

    GetHistory(): Promise<any> {
        if (this.Model == null)
            return Promise.resolve();
        this.IsSubmitting = true;
        return this.complainService.Complain_GetHistory(this.Model.ComplainId).then(data => {
            this.HistoryData = data;
            this.IsSubmitting = false;
        }).catch(err => {
            this.IsSubmitting = false;
        });
    }

    GetWorkOrderRemarks(): void {
        this.workOrderRemarks = null;
        if (this.Model == null || !this.Model.IsKMTCategory)
            return;

        this.complainService.GetWorkOrderDetailForJob(this.Model.ComplainId).then(data => {
            if (data && data.Result) {
                if (data.Result.WorkOrder && data.Result.WorkOrder.Remarks) {
                    let woRemarks = data.Result.WorkOrder.Remarks;
                    if (woRemarks !== this.Model.LastRemarks) {
                        this.workOrderRemarks = woRemarks;
                    }
                }

                if (data.Result.Transactions && data.Result.Transactions.length > 0) {
                    // Only pick AddRemarks (21), AddAttachment (22), ChangeAttachment (37), DeleteJobAttachment (38) from MNT transactions
                    let filteredTransactions = data.Result.Transactions.filter(t => t.Action === 21 || t.Action === 22 || t.Action === 37 || t.Action === 38);
                    if (filteredTransactions.length > 0) {
                        this.mergeWorkOrderHistory(filteredTransactions);
                    }
                }

                this.mergeWorkOrderAttachments(data.Result);
            }
        }).catch(err => {});
    }

    mergeWorkOrderAttachments(result: any): void {
        if (this.Model == null)
            return;

        if (!this.Model.Attachments) {
            this.Model.Attachments = [];
        }

        let woFileAssets: any[] = [];

        // Collect FileAssets from WorkOrder level
        if (result.WorkOrder && result.WorkOrder.FileAssets && result.WorkOrder.FileAssets.length > 0) {
            woFileAssets = woFileAssets.concat(result.WorkOrder.FileAssets);
        }

        // Collect FileAssets from root level
        if (result.FileAssets && result.FileAssets.length > 0) {
            woFileAssets = woFileAssets.concat(result.FileAssets);
        }

        // Collect FileAssets from transactions
        if (result.Transactions && result.Transactions.length > 0) {
            for (let t of result.Transactions) {
                if (t.FileAssets && t.FileAssets.length > 0) {
                    woFileAssets = woFileAssets.concat(t.FileAssets);
                }
            }
        }

        if (woFileAssets.length === 0)
            return;

        // Deduplicate WO file assets by AttachmentId
        let seenIds = {};
        let uniqueWoAssets: any[] = [];
        for (let fa of woFileAssets) {
            let id = fa.AttachmentId || fa.FileAssetId || fa.Id;
            if (id && !seenIds[id]) {
                seenIds[id] = true;
                uniqueWoAssets.push(fa);
            }
        }


        let newAttachments = uniqueWoAssets
            .filter(fa => {
                let attachmentId = fa.AttachmentId || fa.FileAssetId || fa.Id || 0;
                if (!attachmentId) return false;
                // Skip if already present (prevents duplicates on re-open)
                return !this.Model.Attachments.some(a =>
                    a.FileUrl && a.FileUrl.endsWith('/' + attachmentId)
                );
            })
            .map(fa => {
                let attachmentId = fa.AttachmentId || fa.FileAssetId || fa.Id || 0;
                return {
                    CallRegAttachmentId: 0,
                    FileName: fa.FileName || fa.Name || '',
                    Base64String: '',
                    IsDeleted: false,
                    IsWorkOrder: true,
                    FileUrl: AppSettings.URL_Attachments + 'download/' + attachmentId
                };
            });

        this.Model.Attachments = this.Model.Attachments.concat(newAttachments);
        this.Model.NoOfAttachments = this.Model.Attachments.length;
    }

    // Round timestamp to nearest minute for comparison (handles precision differences between APIs)
    getTimeToMinute(time: any): number {
        let d = new Date(time);
        d.setSeconds(0, 0);
        return d.getTime();
    }

    // Map WorkOrderStatuses to CallStatuses for consistent status display
    mapWOStatusToCallStatus(woStatus: number): string {
        switch (woStatus) {
            case 1: return 'USN';   // Created -> Unassigned
            case 2: return 'OPN';   // Started -> Open
            case 3: return 'OPN';   // Assigned -> Open
            case 5: return 'PRK';   // Parked -> Park
            case 7: return 'CLS';   // Closed -> Close
            case 8: return 'CLS';   // Cancelled -> Close
            case 14: return 'OPN';  // InProgress -> Open
            default: return 'OPN';
        }
    }

    mergeWorkOrderHistory(transactions: any[]): void {
        if (!this.HistoryData || !this.HistoryData.ComplainHistory)
            return;

        // Filter out transactions with IsJobAttachment: true
        transactions = transactions.filter(t => !t.IsJobAttachment);

        let propId = this.Model.PropertyId;
        let woHistory = transactions.map(t => {
            let loggedByName = '';
            if (t.LoggedBy != null) {
                loggedByName = this.masterService.MasterData_GetMutli(propId, t.LoggedBy, EntityCodes.Staff, t.LoggedBy);
            }
            let assignedStaffName = '';
            if (t.AssignedStaffId != null) {
                assignedStaffName = this.masterService.MasterData_GetMutli(propId, t.AssignedStaffId, EntityCodes.Staff, t.AssignedStaffId);
            }
            let mappedStatus = this.mapWOStatusToCallStatus(t.Status);
            let statusName = this.masterService.MasterData_GetMutli(propId, mappedStatus, EntityCodes.ComplainSatuses, mappedStatus);
            // MNT returns ActionTime without 'Z' but it's UTC — append Z so JS parses it as UTC
            // (matching service history format which has Z)
            let actionTime = t.ActionTime;
            if (actionTime && !actionTime.endsWith('Z')) {
                actionTime = actionTime + 'Z';
            }
            return {
                ActionTime: actionTime,
                LoggedByName: loggedByName,
                Action: t.Action,
                ActionName: t.ActionDetails || '',
                Status: mappedStatus,
                StatusName: statusName,
                AssignedStaffName: assignedStaffName,
                AssignedStaffId: t.AssignedStaffId,
                ReasonId: t.ReasonId,
                ReasonName: '',
                Remarks: t.Remarks,
                AttachmentName: t.AttachmentName || '',
                IsWorkOrder: true
            };
        });

        // Remove previously merged WO transactions to avoid duplicates on re-open
        this.HistoryData.ComplainHistory = this.HistoryData.ComplainHistory.filter(h => !h.IsWorkOrder);

        // Add WO transactions directly (only remarks and attachment actions are already filtered)
        this.HistoryData.ComplainHistory = this.HistoryData.ComplainHistory.concat(woHistory);
        this.HistoryData.ComplainHistory.sort((a, b) => {
            return new Date(a.ActionTime).getTime() - new Date(b.ActionTime).getTime();
        });
    }

     GetInventoryDetails(): void {
        if (this.Model == null)
            return;
        this.IsSubmitting = true;
        let req: InventoryItemsPayload = {
            ComplainId: this.Model.ComplainId,
            propertyId: this.Model.PropertyId
        }
        this.complainService.GetInventoryDetails(req).then(data => {
            this.JobInventoryDetail = data[0];
           const inventoryDetails: any = this.masterService.getInventoryDetailsById(this.Model.PropertyId,  this.JobInventoryDetail.InventoryItemId);
            let stockLocationDetails = this.masterService.FindLocation(this.Model.PropertyId, this.JobInventoryDetail.StockLocationId);
           if(inventoryDetails){
                this.JobInventoryDetail['Name'] = inventoryDetails.Name;
                this.JobInventoryDetail['ItemType'] = inventoryDetails.ItemType;

                if(stockLocationDetails && stockLocationDetails.Description){
                    this.JobInventoryDetail['StockLocationName'] = stockLocationDetails.Description;
                }
           }

            this.GetInventoryItemLocations();
            this.IsSubmitting = false;
        }).catch(err => {
            this.IsSubmitting = false;
        });
    }

    getGuestDataInventory(): void {
        if (this.Model == null)
            return;
        this.IsSubmitting = true;
          let req: any = {
            TritonReservationId: this.Model.ComplainId,
            PropertyId: this.Model.PropertyId
        }
        this.complainService.GetGuestDetailsForInventory(req).then(data => {
            if(data && data.JobInventoryGuestDetails){
              this.jobOperations.guestInventoryDetail = data.JobInventoryGuestDetails;
            }
            this.IsSubmitting = false;
        }).catch(err => {
            this.IsSubmitting = false;
        });

        if (  this.jobOperations && this.jobOperations.guestInventoryDetail &&  this.jobOperations.guestInventoryDetail.GuestCheckOutAt && 
                typeof  this.jobOperations.guestInventoryDetail.GuestCheckOutAt === 'string') {
            this.jobOperations.guestInventoryDetail.GuestCheckOutAt = new Date( this.jobOperations.guestInventoryDetail.GuestCheckOutAt);
            }

        if ( this.jobOperations && this.jobOperations.guestInventoryDetail && this.jobOperations.guestInventoryDetail.GuestCheckInAt && 
            typeof  this.jobOperations.guestInventoryDetail.GuestCheckInAt === 'string') {
            this.jobOperations.guestInventoryDetail.GuestCheckInAt = new Date( this.jobOperations.guestInventoryDetail.GuestCheckInAt);
        }
    }

    GetInventoryItemLocations(): void {
        if (this.Model == null)
            return;
        this.IsSubmitting = true;
        
        let InventoryItemId: any = this.JobInventoryDetail.InventoryItemId;
        this.complainService.GetInventoryItemLocations(InventoryItemId).then(data => {
            if(data && data.data && data.data.stocks){
            this.JobInventoryLocations.JobInventoryLocations = data.data.stocks;
            }
            let allLocations = _.cloneDeep(
                        this.masterService.GetLocations(this.Model.PropertyId)
                    );
                    if(this.JobInventoryLocations.JobInventoryLocations && this.JobInventoryLocations.JobInventoryLocations.length){
                        this.JobInventoryLocations.JobInventoryLocations = this.JobInventoryLocations.JobInventoryLocations.map(location => {
                        const match = allLocations.find(loc => loc.Id === location.locationId);
                        return {
                            ...location,
                            LocationName: match ? match.Description : location.locationId
                        };
                        });
                    }

            this.IsSubmitting = false;
        }).catch(err => {
            this.IsSubmitting = false;
        });
    }

    onOperation(Mode: JobOperationActions): void {
        this.SetUpdateModel();
        switch (Mode) {
            case JobOperationActions.Close:
                this.jobOperations.JobInventoryLocations = this.JobInventoryLocations;
                this.jobOperations.onOpen(Mode, this.UpdateModel, this.Model);
                break;
            case JobOperationActions.ReAssign:
                this.manualAssign.OpenForAssignment(this.Model.CallDescriptionsId, this.Model.LocationId, this.Model.PropertyId, this.Model);
                break;
            case JobOperationActions.Park:
                this.jobOperations.onOpen(Mode, this.UpdateModel, this.Model);
                break;
            case JobOperationActions.Reopen:
                this.jobOperations.onOpen(Mode, this.UpdateModel, this.Model);
                break;
            case JobOperationActions.Reset:
                this.jobOperations.onOpen(Mode, this.UpdateModel, this.Model);
                break;
            case JobOperationActions.AddRemarks:
                this.jobOperations.onOpen(Mode, this.UpdateModel, this.Model);
                break;
        }
    }

    onSelectedStaff(StaffId: number): void {

    }

    onClose(): void {
        this.Model = null;
        this.complainService.SelectedJob = null;
    }

    ResetAttachmentCount(): void {
        if (this.Model.Attachments != null && this.Model.Attachments.length == 0) {
            this.Model.NoOfAttachments = 0;
        }
        else {
            this.Model.NoOfAttachments = this.Model.Attachments.length;
        }
    }

    onAttachmentChanged(data: ComplainAttachment[]): void {
        this.Model.Attachments = data;
        this.ResetAttachmentCount();
        this.GetHistory().then(() => {
            this.GetWorkOrderRemarks();
        });
    }

    onDeleteAttachment(row: ComplainAttachment): void {
        let deleteText = this.translate.instant('LBL.DELETE_CONFIRM');
        let confirmDelete = confirm(deleteText+"?");
        if (!confirmDelete)
            return;

        let req = _.cloneDeep(this.UpdateModel);
        req.Operation = JobOperationActions.ChangeAttachments;

        req.Attachments = [];

        row.IsDeleted = true;
        req.Attachments.push(row);

        this.complainService.Complain_Update(req).then(data => {
            this.FromBaseResponse(data);
            if (this.HasErrors)
                return;

            //row = data.Result;

            this.GetMultilingualToast('TS.TS_FILE_DELETED_SUCCESS', 'success');

            this.GetHistory().then(() => {
            this.GetWorkOrderRemarks();
        });
        });
    }

    onTagStaff(): void {
        this.tagStaff.Open(this.Model.ComplainId, EntityCodes.Complain, this.Model.PropertyId, this.Model);
    }

    onSendMessage(): void {
        if (this.Model.AssignedTo != null) {
            this.sendMsg.Open(this.Model.ComplainId, EntityCodes.Complain, this.Model.AssignedTo, this.Model.PropertyId, this.Model);
        }
    }

    onCopyToGlitch(): void {
        this.masterService.GetGlitchDescriptionForCall(this.Model.CallDescriptionsId, this.Model.PropertyId).then(data => {
            let row = new Glitch_UpdateRequest();
            row.DescriptionId = data;

            row.PropertyId = this.Model.PropertyId;
            row.GlitchGuestId = this.Model.RequestedByGuestId;
            row.IncidentLocationId = this.Model.LocationId;
            row.GlitchStaffId = this.Model.LoggedBy;
            this.masterService.TransferModel = row;
            this.router.navigateByUrl("/home/Glitch/RegisterGlitch");

        });

    }

    onWorkorder(model: ComplainRegister){
        if(model){
            let reqComplainEnableKMT= new ComplainEnableKMT();
            reqComplainEnableKMT.CategoryId = model.CategoryId;
            reqComplainEnableKMT.ComplainId = model.ComplainId;
            reqComplainEnableKMT.PropertyId = model.PropertyId;
            this.complainService.Complain_EnableKMT(reqComplainEnableKMT).then(data => {
                this.FromBaseResponse(data);
            if (this.HasErrors) {
                return;
            }
            if(data && data.Result && data.Result.IsKMTCategory){
                 model.IsKMTCategory = data.Result.IsKMTCategory;
                 model.IsControlWithKSV = data.Result.IsControlWithKSV;
                this.GetMultilingualToast('TS.TS_ALERT_WORKORDER_IS_CREATED_SUCCESSFULLY', 'success');
            }
          
            });
        }
    }

    setInventoryItemType() {
         if(this.Model && this.Model.PropertyId && this.Model.CallDescriptionsId){
            let invData: any =  this.masterService.getInventoryDetailByPropertyDescription(this.Model.PropertyId, this.Model.CallDescriptionsId);
            if(invData && invData.ItemType){
                this.inventoryItempType = invData.ItemType;
            }else {
                this.inventoryItempType = '';
            }
        }
    }

}
